import { render } from "./Myinventory.vue?vue&type=template&id=475ba247&scoped=true"
import script from "./Myinventory.vue?vue&type=script&lang=js"
export * from "./Myinventory.vue?vue&type=script&lang=js"

import "./Myinventory.vue?vue&type=style&index=0&id=475ba247&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475ba247"]])

export default __exports__